/*
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-09-03 10:27:05
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-24 10:16:04
 * @FilePath: /erp-admin/src/utils/specialCompany.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { computed } from 'vue'
import store from '@/store'

/**
 * 建议售价 改为批发价 （price）
 * @param {*} type 类型
 * @param {*} isWholesale 是否是批发的公司
 * @returns 
 */
export function getAdvisePriceLabel(type = '', isWholesale = false) {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': '批发价', // XCXX
        "hg8fa286ab8f434d8f": '批发价'
    }
    if (isWholesale) {
        return !!obj[companyId]
    }
    return obj[companyId] || (type === 'sku' ? '售价' : '建议售价')
}

/**
 * 最低售价 改为批发原价 （rt_price）
 * @param {*} type 类型
 * @param {*} isWholesale 是否是批发的公司
 * @returns 
 */
export function getLowestPriceLabel(type = '', isWholesale = false) {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': '批发原价', // XCXX
        "hg8fa286ab8f434d8f": '批发原价'
    }
    if (isWholesale) {
        return !!obj[companyId]
    }
    return obj[companyId] || (type === 'sku' ? '批发原价' : '最低售价')
}
/**
 * 原厂零售价 零售原价 （orgf_price）
 * @param {*} type 类型
 * @param {*} isWholesale 是否是批发的公司
 * @returns 
 */
export function getRetailPriceLabel(type = '', isWholesale = false) {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': '零售原价', // XCXX
        "hg8fa286ab8f434d8f": '零售原价'
    }
    if (isWholesale) {
        return !!obj[companyId]
    }
    return obj[companyId] || (type === 'sku' ? '零售原价' : '原厂零售价')
}


// 滚动条加粗
export const isScrollbarBlodCompany = computed(() => {
    const SCROLLBAR_BLOD_COMPANY = [
        'hg7ca286ab8f432b4c', // 乐穗
        'hg861ba25023ca07d8', // 嘉力德
        'hg8fa286ab8f434d8f', // 鲸苇科技
        'hg8fa286ab8f434d8f', // 测试环境
    ]
    // 滚动条加粗电话用户
    const SCROLLBAR_BLOD_PHONE = [
        '13806102430', // 姚波
    ]
    const userInfo = store.getters['user/userInfo']
    if (
        userInfo?.tel &&
        SCROLLBAR_BLOD_PHONE.includes(userInfo?.tel)
    ) {
        return true
    }
    return SCROLLBAR_BLOD_COMPANY.includes(userInfo?.company_id)
})

// 商品管理可以修改库存的公司
export const getStockCompany = () => {
    const STOCK_MODIFY_COMPANY = [
        // 'hg8fa286ab8f434d8f', // 测试环境
        'hg3e41d3e99d9f534e', // 时光前行
    ]
    const companyId = LS.get('companyId')
    return STOCK_MODIFY_COMPANY.includes(companyId)
}
/**
 * 仅显示提审并通过按钮
 * @returns 
 */
export function onlyShowCommitAuditBtn() {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': '提审并通过', // XCXX
        // "hg8fa286ab8f434d8f": '提审并通过' // 测试环境
    }
    return !!obj[companyId]
}
/**
 * 隐藏OEM编码
 * @returns 是否隐藏OEM编码
 */
export function hideOemCode() {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': true, // XCXX
    }
    return !obj[companyId]
}
/**
 * 隐藏保存并新增按钮
 * @returns 是否隐藏保存并新增按钮
 */
export function hideSaveAndAddBtn() {
    const companyId = LS.get('companyId')
    const obj = {
        'hgbfc6ba3d08d92ad0': true, // XCXX
    }
    return !!obj[companyId]
}

/**
 * 获取最小数量
 * @returns 最小数量
 */
export function getMinNum() {
    const companyId = LS.get('companyId')
    const minNumZeroArray = [
        'hg5a7a414e4feea9cd', // WMS
    ]
    if (minNumZeroArray.includes(companyId)) return 0
    return 0
}